import React, { useState, useEffect } from "react";
import apiService from "../services/api.service";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectCartCount, selectCartItems } from "../Redux/shoppingCartReducer";
import "../i18n/config";
import i18next from "i18next";
import { Row, Col, Spinner } from "react-bootstrap";
import Modal from 'react-modal';
import { setUser } from "../Redux/userReducer";
import { eventService } from "../services/event.service";
import { ErrorCodes, OrderStatus, ProductType } from "../data/enums";
import { useTranslation } from "../hooks/useTranslation";

function PersonalDetailsFormComponent({ register, handleSubmit, errors, setValue, setFocus, loading, setLoading, sendToGifteeTime,onDetailsSubmit,agreeToReceiveEmailsChecked,
  setAgreeToReceiveEmailsChecked, ...props }) {
  const [lang, setLang] = useState("");

  const [clubconditionsChecked, setClubconditionsChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [modalTermsIsOpen, setModalTermsIsOpen] = useState(false);
  const [modalPrivacyIsOpen, setModalPrivacyIsOpen] = useState(false);
  const [termsText, setTermsText] = useState("");
  const [privacyText, setPrivacyText] = useState("");
  const [isCheckedUser, setIsCheckedUser] = useState(false);
  const [isShowVrifyField, setISshowVrifyField] = useState(false);
  const [smsMsg, setSmsMsg] = useState("");
  const [paybyOtherChecked, setPaybyOtherChecked] = useState(false);


  const [customerPhone, setCustomerPhone] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerPassport, setCustomerPassport] = useState("");

  // Move focus to the verification code input when it appears so keyboard
  // and screen reader users land on the right field without manual navigation.
  useEffect(() => {
    if (isShowVrifyField) {
      setFocus("VerifCodeInput");
    }
  }, [isShowVrifyField]);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  let cartItems = useSelector(selectCartItems);

  const qty = cartItems[Object.keys(cartItems)[0]].qty;
  const productsFromSession = window.sessionStorage.getItem("products");
  cartItems = productsFromSession ? JSON.parse(productsFromSession) : cartItems;
  const loggedUser = useSelector((state) => state.user.user)
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  const chain = useSelector((state)=>state.chain);
  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "en");
    findLoggedUser();
  }, []);

  useEffect(() => {
    SetLanguage(lang);
    if(lang){
      getChainTerms();
    }
  }, [lang]);

  const getChainTerms = () => {
    let privacyText = null;
    let termsText = null;

    apiService.getChains(chainId)
      .then(response => {
        if (response.data && response.data.data && !response.data.data[0].errors) {
          const res = response.data.data[0];
          if (res && res.translations) {
            const translation = res.translations.find(t => t.languageIsoCode == lang);
            if (translation && translation.termsAndConditions) {
              termsText = translation.termsAndConditions;
            }
            if (translation && translation.privacyPolicy) {
              privacyText = translation.privacyPolicy;
            }
          }
        }
        if (!privacyText) {
          getDefaultTerms("privacy")
        } else {
          setPrivacyText(privacyText);
        }
        if (!termsText) {
          getDefaultTerms("terms")
        } else {
          setTermsText(termsText);
        }
      })
      .catch(error => {
        getDefaultTerms("terms")
        getDefaultTerms("privacy")
      });
  }

  const submitForm = (data) => {
    let valid = true;
    let errorMsg = "";

    if (!valid) {
        errorMsg = t("CheckAllFields");
        alert(errorMsg);
    } else {
        if (!clubconditionsChecked) {
            setErrorMessage(t("MustAgreeToTerms"));
        } else {
            const customerDetails = {
                firstName: data.firstNameInput || data.fullNameInput.split(" ")[0],
                lastName: data.lastNameInput || data.fullNameInput.split(" ")[1],
                email: data.EmailInput,
            };

            onDetailsSubmit(customerDetails); // Pass details to parent
            // Continue with existing flow
            if (!isCheckedUser) {
                checkCustomer(data.EmailInput, data);
            } else if (isShowVrifyField) {
                checkVerificationCode(data.EmailInput, data.VerifCodeInput);
            } else {
                registerUser(data);
            }
        }
    }
};

  const registerUser = (data) => {
    let myCustomer = {
      customerId: null,
      customerFirstName: chain.displayFullGuestName
        ? data.fullNameInput.substring(0, data.fullNameInput.indexOf(" "))
        : data.firstNameInput,
      customerLastName: chain.displayFullGuestName
        ? data.fullNameInput.substring(data.fullNameInput.indexOf(" ") + 1)
        : data.lastNameInput,
      customerIdentification: data.PassportInput ? data.PassportInput : "",
      customerEmail: data.EmailInput,
      customerPhone: data.PhoneInput ?? "",
      customerCountry: "",
      customerCity: "",
      customerAddress: "",
      customerPostalCode: "",
      customerLanguageIsoCode: lang,
    };
  
    let gifteeDtls = {};
  
    if (data.GiftfullNameInput && data.GiftfullNameInput.length > 1) {
      gifteeDtls = {
        GiftfullNameInput: data.GiftfullNameInput,
        GiftEmailInput: data.GiftEmailInput,
        GiftFreeTextInput: data.GiftFreeTextInput,
        GiftSenderfullNameInput: data.GiftSenderfullNameInput,
        GifteePhoneInput: data.GifteePhoneInput,
      };
    }
  
    let errmsg = "";
    if (
      data.GiftfullNameInput &&
      data.GiftfullNameInput.length > 1 &&
      !data.GiftEmailInput &&
      !data.GifteePhoneInput
    ) {
      errmsg = t("FillEmailOrPhone");
      setErrorMessage(errmsg);
      alert(errmsg);
    } else {
      setErrorMessage("");
      apiService.getCustomer(data.EmailInput).then(
        (response) => {
          if (response.data.data && response.data.data.length > 0) {
            var custId = response.data.data[response.data.data.length - 1].customerId;
            myCustomer.customerId = custId;
          }
  
          continueOrderProc(
            myCustomer,
            gifteeDtls,
            data.payerNameInput ? data.payerNameInput : "",
            data.payerCompIDInput ? data.payerCompIDInput : ""
          );
        },
        (error) => {
          continueOrderProc(
            myCustomer,
            gifteeDtls,
            data.payerNameInput ? data.payerNameInput : "",
            data.payerCompIDInput ? data.payerCompIDInput : ""
          );
        }
      );
    }
  };
  

  const continueOrderProc = (myCustomer, myGifteeDtls, payerName, payerCompID) => {
    let products = cartItems;
    if (clubconditionsChecked) {
      const chainId = new URLSearchParams(location.search).get("chainid") || 0;
      if (Object.keys(products).length > 0) {

        let customerIp = "";
        let customerBrowserAgent = navigator.userAgent;

        setLoading(true);
        apiService.getUserIp().then(
          (response) => {
            customerIp = response;
          },
          (error) => {

          }
        )
          .finally(
            () => {
              setOrderAfterAllChecks(chainId, products, myCustomer, myGifteeDtls, customerIp, customerBrowserAgent, payerName, payerCompID)
            }
          );

      }
    }
    else {
      setErrorMessage(t("MustAgreeToTerms"));
    }


  };
  const setOrderProducts = (currentProduct, blockingIdentifier) => {
    const packageSpecDatesOrderReq = [
      {
        orderId: sessionStorage.getItem("lastOrderNum"),
        orderDates: currentProduct.dates?.length
          ? [
            currentProduct.dates[0].fromDate,
            currentProduct.dates[0].toDate,
          ] : [],
        productBlockingIdentifier: blockingIdentifier,
        currencyCode: currentProduct.currencyCode,
        duration: currentProduct.duration,
        productId: currentProduct.productId,
        productTypeId: currentProduct.productTypeId,
        price: currentProduct.productPrice,
        quantity: qty,
        productCategoryId: currentProduct.productCategoryId
      }
    ]
    apiService.setOrderProducts(packageSpecDatesOrderReq).then();
  }

  const setOrderAfterAllChecks = (chainId, products, myCustomer, myGifteeDtls, customerIp, customerBrowserAgent, payerName, payerCompID) => {
    setLoading(true);

    // check if the product still available before payment
    const currentItem = Object.keys(cartItems)[0];
    const currentProduct = products[currentItem].selectedProduct;
    const blockingIdentifier = sessionStorage.getItem("productBlockingIdentifier") || null;

    if (blockingIdentifier && currentProduct?.productId) {

      apiService.getBlockedProduct(currentProduct.productId, blockingIdentifier)
        .then(response => {

          if (!response.errors && response.data && response.data.data && response.data.data.length) {
            if (response.data.data[0].isValid) {

              let gifteeMsg = "";
              if(myGifteeDtls && myGifteeDtls.GiftFreeTextInput && myGifteeDtls.GiftFreeTextInput.length > 0){
                gifteeMsg = myGifteeDtls.GiftFreeTextInput + " </br>" + t("SentFrom");

                // if the language is not Hebrew, add a space before the sender's name for proper formatting
                if(lang != 'he'){   
                  gifteeMsg += " ";
                }

                gifteeMsg += myGifteeDtls.GiftSenderfullNameInput;

              }
              
              apiService
                .setOrder(
                  chainId,
                  products,
                  myCustomer,
                  myGifteeDtls,
                  lang,
                  customerIp,
                  customerBrowserAgent,
                  gifteeMsg,
                  payerName,
                  payerCompID,
                  OrderStatus.InProcess,
                  sendToGifteeTime,
                  blockingIdentifier,
                  agreeToReceiveEmailsChecked
                ).then((res) => {
                  if (res) {
                    props.onInsertCartInProgressComplete();
                    eventService.beginCheckout();

                    if (currentProduct.productTypeId === ProductType.PackageSpecDates) {
                      setOrderProducts(currentProduct, blockingIdentifier);
                    }
                  }
                  else {
                    console.error(res)
                    alert(t("SomethingWentWrong") + "\n" + t("ErrorCode") + ErrorCodes.SetOrder);
                  }
                })
                .catch((err) => {
                  console.error(err);
                  alert(t("SomethingWentWrong") + "\n" + t("ErrorCode") + ErrorCodes.SetOrder);
                })
                .finally(() => setLoading(false))
            }
            else {
              alert(t("ProductNotAvailableAnymore"));
            }
          } else {
            alert(t("ProductNotAvailableAnymore"));
          }
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
          alert(t("SomethingWentWrong") + "\n" + t("ErrorCode") + ErrorCodes.GetBlockedProduct);
        })
    }
  }

  const clubconditionsCheckChanges = (isChecked) => {
    setClubconditionsChecked(isChecked);
    setErrorMessage("");
  };


  const getDefaultTerms = (paramtoRead) => {

    apiService.getGlobalParameters(paramtoRead).then(
      (response) => {

        if (response.data && response.data.data && response.data.data.length > 0) {
          let termstext = getChainTermsTranslations(response.data.data[0]);
          termstext = termstext && termstext.globalParameterValue ? termstext.globalParameterValue : response.data.data[0].globalParameterValue;
          if (paramtoRead === "terms") {
            setTermsText(termstext)
          }
          if (paramtoRead === "privacy") {
            setPrivacyText(termstext)
          }

        }

      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );

  };

  const getChainTermsTranslations = (objectToTranslate) => {
    if (objectToTranslate && objectToTranslate.translations) {
      let ObjectTranslations = objectToTranslate.translations.filter((p) => {
        return p.languageIsoCode == lang || p.languageIsoCode == new URLSearchParams(location.search).get("lang");
      });
      return ObjectTranslations.length > 0 ? ObjectTranslations[0] : {};
    }
    return {};
  };


  const checkCustomer = (myEmail, data) => {
    const propertyId = productsFromSession[0].propertyId ? productsFromSession[0].propertyId : 0;
    const chainId = new URLSearchParams(location.search).get("chainid") || 0;

    const sendEmailOrSms = (lang === 'he'
      ? apiService.sendIdentityVerificationSms(myEmail, propertyId, chainId)
      : apiService.sendIdentityVerificationEmail(myEmail, propertyId, chainId)
    )
    setLoading(true)

    sendEmailOrSms
      .then((res) => {
        if (res.Success === true) {
          setIsCheckedUser(true);
          setISshowVrifyField(true);
          setSmsMsg(t("SmsWasSent")
            + " <div class='phonenum'>"
            + res[lang === 'he' ? 'MaskedPhoneNumber' : 'MaskedEmail']
            + "</div>");
        }
        else {
          apiService.getCustomer(myEmail).then(
            (response) => {

              if (response.data.data && response.data.data.length > 0) {
                var custId = response.data.data[response.data.data.length - 1].customerId;
                if (custId > 0) {
                  setSmsMsg(t("CantSendSmsToExistimCustomer"))
                }
                else {
                  setIsCheckedUser(true);
                  registerUser(data);
                }
              }
              else {
                setIsCheckedUser(true);
                registerUser(data);
              }
            },
            (error) => {
              const _content =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        }
      })
      .catch((err) => {
        console.error(err);
        setSmsMsg(t("VerificationError"))
      })
      .finally(() => setLoading(false));
  };


  const checkVerificationCode = (Email, VerificationCode) => {
    setLoading(true);

    apiService
      .verifyIdentityBySms(Email, VerificationCode)
      .then((res) => {
        if (res.customerEmail == Email) {
          setIsCheckedUser(true);
          setISshowVrifyField(false);
          setCustomerName(res.customerFirstName + " " + res.customerLastName);
          setCustomerPhone(res.customerPhone);
          setCustomerPassport(res.customerIdentification);

          setValue("fullNameInput", res.customerFirstName + " " + res.customerLastName, { shouldDirty: true });
          setValue("PhoneInput", res.customerPhone, { shouldDirty: true });
          setValue("PassportInput", res.customerIdentification, { shouldDirty: true });

          let loggedUser =
          {
            id: res.customerId,
            email: res.customerEmail

          }
          dispatch(setUser(loggedUser))

          setSmsMsg(t("SuccessfullVerification"));
          setTimeout(() => {
            setSmsMsg("");
          }, 3000);
        }
        else {
          setSmsMsg(t("FailedVerification"))
        }
      })
      .catch((err) => {
        console.error(err);
        setSmsMsg(t("VerificationError"))
      })
      .finally(() => setLoading(false));
  };


  const findLoggedUser = () => {


    if (loggedUser) {

      apiService.getCustomer(loggedUser.email).then(
        (response) => {

          if (response.data.data && response.data.data.length > 0) {
            var custId = response.data.data[response.data.data.length - 1].customerId;
            let user = response.data.data[response.data.data.length - 1];
            if (custId != loggedUser.id) {
              logout();
            }
            else {
              setIsCheckedUser(true);
              if (chain.displayFullGuestName) {
                setValue(
                  "fullNameInput",
                  `${user.customerFirstName} ${user.customerLastName}`,
                  { shouldDirty: true }
                );
              } else {
                setValue("firstNameInput", user.customerFirstName, { shouldDirty: true });
                setValue("lastNameInput", user.customerLastName, { shouldDirty: true });
              }
              setValue("EmailInput", user.customerEmail, { shouldDirty: true });
              setValue("PhoneInput", user.customerPhone, { shouldDirty: true });
              setValue("PassportInput", user.customerIdentification, { shouldDirty: true });
              setCustomerName(user.customerFirstName + " " + user.customerLastName);
              setCustomerPhone(user.customerPhone);
              setCustomerPassport(user.customerIdentification);
            }

          }
          else {
            logout();
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );

    }
    else {
      logout();
    }

  }


  const logout = () => {

  }

  const passportValidation = (value) => {
    let id = String(value).trim();
    if (id.length > 9 || id.length < 5 || isNaN(id)) {
      return t("InvalidPassport");
    }

    // Pad string with zeros up to 9 digits
    id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
    const isIdStructureValid = (Array
      .from(id, Number)
      .reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) % 10 === 0);
    if (!isIdStructureValid) {
      return t("InvalidPassport");
    }

    return true;
  }


  const PaybyOtherCheckChanged = (isChecked) => {
    setPaybyOtherChecked(isChecked);
    if (isChecked) {

    }


  };

  return (
    <>
      <form onSubmit={handleSubmit((data) => submitForm(data))} aria-labelledby="details-label">
        <div className="personal-details-form-wrap">
          {/* role="status" is an implicit aria-live="polite" region — must always
              stay in the DOM so the browser notices content changes and announces them.
              Hiding with display:none removes it from the a11y tree and kills the announcement. */}
          <Row>
            <Col>
              <div
                role="status"
                aria-live="polite"
                aria-atomic="true"
                className={smsMsg ? "conf-msg" : ""}
                dangerouslySetInnerHTML={{ __html: smsMsg ?? "" }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <label htmlFor="EmailInput"> {t("Email")}</label>
              <input type="email"
                id="EmailInput"
                name="EmailInput"
                {...register("EmailInput", {
                  required: t("Required"),
                  pattern: {
                    value: new RegExp(t("EmailRegex")),
                    message: t("EmailRegexMsg"),
                  },
                })}
                disabled={isCheckedUser ? 'disabled' : ''}
                aria-describedby="EmailInput-error"
              />
              <span id="EmailInput-error" className="error">{errors.EmailInput?.message}</span>
            </Col>
          </Row>

          {isShowVrifyField && <Row>
            <Col>
              <label htmlFor="VerifCodeInput"> {t("VerificationCode")}</label>
              <input
                id="VerifCodeInput"
                type="text"
                name="VerifCodeInput"
                {...register("VerifCodeInput", {
                  required: t("Required"),

                })}
                aria-describedby="VerifCodeInput-error"
              />
              <span id="VerifCodeInput-error" className="error">{errors.VerifCodeInput?.message}</span>
            </Col>
          </Row>}

          {isShowVrifyField ? <Row>
            <Col>
              <input
                aria-label={t("ConfirmVerfCode")}
                type="submit"
                className="btn"
                value={t("ConfirmVerfCode")}

              />
            </Col>
          </Row> : null}

          <div className={isShowVrifyField ? "hidden" : ""}>
          <Row>
              {chain.displayFullGuestName ? (
                <Col>
                  <label htmlFor="fullNameInput">{t("FullName")}</label>
                  <input
                    id="fullNameInput"
                    type="text"
                    name="fullNameInput"
                    {...register("fullNameInput", {
                      required: !isShowVrifyField ? t("Required") : false,
                      pattern: {
                        value: new RegExp(t("FullNameRegex")),
                        message: t("FullNameRegexMsg"),
                      },
                    })}
                    disabled={customerName !== "" ? "disabled" : ""}
                    aria-describedby="fullNameInput-error"
                  />
                  <span id="fullNameInput-error" className="error">{errors.fullNameInput?.message}</span>
                </Col>
              ) : (
                <>
                  <Col>
                    <label htmlFor="firstNameInput">{t("FirstName")}</label>
                    <input
                      id="firstNameInput"
                      type="text"
                      name="firstNameInput"
                      {...register("firstNameInput", {
                        required: !isShowVrifyField ? t("Required") : false,
                        pattern: {
                          value: new RegExp(t("NameRegex")),
                          message: t("NameRegexMsg"),
                        },
                      })}
                      disabled={customerName !== "" ? "disabled" : ""}
                      aria-describedby="firstNameInput-error"
                    />
                    <span id="firstNameInput-error" className="error">{errors.firstNameInput?.message}</span>
                  </Col>
                  <Col>
                    <label htmlFor="lastNameInput">{t("LastName")}</label>
                    <input
                      id="lastNameInput"
                      type="text"
                      name="lastNameInput"
                      {...register("lastNameInput", {
                        required: !isShowVrifyField ? t("Required") : false,
                        pattern: {
                          value: new RegExp(t("LastNameRegex")),
                          message: t("LastNameRegexMsg"),
                        },
                      })}
                      disabled={customerName !== "" ? "disabled" : ""}
                      aria-describedby="lastNameInput-error"
                    />
                    <span id="lastNameInput-error" className="error">{errors.lastNameInput?.message}</span>
                  </Col>
                </>
              )}
           </Row>
            {
              lang === 'he' &&
              <Row>
                <Col>
                  <label htmlFor="PhoneInput"> {t("Phone")} <br /> {customerPhone === "" && <span className="phone-comment">* {t("PhoneComment")}</span>}</label>
                  <input
                    name="PhoneInput"
                    type="tel"
                    id="PhoneInput"
                    {...register("PhoneInput", {
                      required: !isShowVrifyField ? t("Required") : false,
                      pattern: {
                        value: new RegExp(t("PhoneRegex")),
                        message: t("PhoneRegexMsg"),
                      },
                    })}
                    disabled={customerPhone != "" ? 'disabled' : ''}
                    aria-describedby="PhoneInput-error"
                  />
                  <span id="PhoneInput-error" className="error">{errors.PhoneInput?.message}</span>
                </Col>
              </Row>
            }
            {
              lang === 'he' &&
              <Row>
                <Col>
                  <label htmlFor="PassportInput"> {t("Passport")}</label>
                  <input
                    type="tel"
                    id="PassportInput"
                    name="PassportInput"
                    {...register("PassportInput", {
                      required: isCheckedUser && !isShowVrifyField ? t("Required") : false,
                      validate: !isShowVrifyField ? {
                        validateID: passportValidation
                      } : null
                    })}
                    disabled={customerPassport != "" ? 'disabled' : ''}
                    aria-describedby="PassportInput-error"
                  />
                  <span id="PassportInput-error" className="error">{errors.PassportInput?.message}</span>
                </Col>
              </Row>
            }
            <div className="payByOtherWrap checkboxWrap">
              <div className="payByOther">
                <input id="PayByOther" aria-label={t("PayByOther")} type="checkbox" className="checkbox" value={paybyOtherChecked} onChange={e => PaybyOtherCheckChanged(!paybyOtherChecked)} />
                <label htmlFor="PayByOther">{t("PayByOther")}</label>
              </div>
              {paybyOtherChecked &&
                <>
                  <Row>
                    <Col>
                      <label htmlFor="payerNameInput"> {t("PayerName")}</label>
                      <input
                        id="payerNameInput"
                        type="text"
                        name="payerNameInput"
                        {...register("payerNameInput", {
                          required: paybyOtherChecked ? t("Required") : false,
                          minLength: 2,
                        })}
                        aria-describedby="payerNameInput-error"
                      />
                      <span id="payerNameInput-error" className="error">
                        {errors.payerNameInput?.message}
                        {
                          errors.payerNameInput && errors.payerNameInput.type === "minLength" && (
                            <span className="error"><br/>{t("AtLeast2Chars")}</span>
                          )
                        }
                      </span>
                      
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label htmlFor="payerCompIDInput"> {t("PayerCompID")}</label>
                      <input
                        id="payerCompIDInput"
                        type="text"
                        name="payerCompIDInput"
                        {...register("payerCompIDInput", {
                          required: paybyOtherChecked ? t("Required") : false,
                          pattern: {
                            value: new RegExp(t("NumbersRegex")),
                            message: t("NumbersRegexMsg"),
                          },
                          minLength: 6,
                        })}
                        aria-describedby="payerCompIDInput-error"
                      />
                      <span id="payerCompIDInput-error" className="error">
                        {errors.payerCompIDInput?.message}
                        {errors.payerCompIDInput && errors.payerCompIDInput.type === "minLength" && (
                          <span className="error"><br/>{t("AtLeast6Numbers")}</span>
                        )}
                      </span>
                      
                    </Col>
                  </Row>
                </>
              }

            </div>
            <Row>
              <Col className="checkboxWrap">
                <input
                  id="readTerms"
                  aria-label={`${t("ReadTerms")} ${t("SiteTerms")} ${t("AndAlso")} ${t("SitePrivacy")}`}
                  type="checkbox"
                  className="checkbox"
                  checked={clubconditionsChecked}
                  onChange={e => clubconditionsCheckChanges(!clubconditionsChecked)}
                />
                <div>
                  <label className="m-0" htmlFor="readTerms">
                    {t("ReadTerms")}
                  </label>&nbsp;
                  <a onClick={() => setModalTermsIsOpen(true)} className="terms-link">
                    {t("SiteTerms")}
                  </a>&nbsp;
                  <label className="m-0" htmlFor="readTerms">
                    {t('AndAlso')}
                  </label>&nbsp;
                  <a onClick={() => setModalPrivacyIsOpen(true)} className="terms-link">
                    {t("SitePrivacy")}
                  </a>
                </div>
              </Col>
            </Row>
            {chain?.translations?.find((t) => t.languageIsoCode === lang)?.newsletterType && (
              <Row>
                <Col className="checkboxWrap">
                    <input
                      id="agreeToReceiveEmails"
                      type="checkbox"
                      className="checkbox"
                      checked={agreeToReceiveEmailsChecked}
                      onChange={() =>
                        setAgreeToReceiveEmailsChecked(!agreeToReceiveEmailsChecked)
                      }
                    />
                    <label htmlFor="agreeToReceiveEmails">
                      {t("AcceptNews")}
                    </label>
                </Col>
              </Row>
            )}
            <Row>
              <Col className="error" aria-live="polite">
                {errorMessage && errorMessage.length > 1 ? errorMessage : null}
              </Col>
            </Row>
            <Row>
              <Col>
                <Col sm={12} className="book-btn text-start"><button className="btn long-button" type="submit" disabled={loading}>{loading && <Spinner className="spinner" animation="border" />} {t("ContinueToPayment")}</button></Col>

                {/* <input
                  type="submit"
                  className="btn"
                  value={t("ContinueToPayment")}
                /> */}
              </Col>
            </Row>
          </div>

        </div>
      </form>

      <Modal
        isOpen={modalTermsIsOpen}
        contentLabel={t("AgreeToTermsEnd")}
        className='terms-modal'  >
        <div className="modal-header">
          <button type="button" className="close" aria-label={t("Close")} onClick={e => setModalTermsIsOpen(false)}><span aria-hidden="true">×</span></button>
          <h4 className="modal-title" aria-label={t("TermsTitle")}>{t("TermsTitle")}</h4>
        </div>
        <div className="modal-body" dangerouslySetInnerHTML={{ __html: termsText }}>

        </div>
      </Modal>

      <Modal
        isOpen={modalPrivacyIsOpen}
        contentLabel={t("AgreeToTermsEnd")}
        className='terms-modal'  >
        <div className="modal-header">
          <button type="button" className="close" onClick={e => setModalPrivacyIsOpen(false)}><span aria-hidden="true">×</span></button>
          <h4 className="modal-title">{t("PrivacyTitle")}</h4>
        </div>
        <div className="modal-body" dangerouslySetInnerHTML={{ __html: privacyText }}>

        </div>
      </Modal>
    </>

  );
}

export default PersonalDetailsFormComponent;
